import { useEffect, useState } from 'react';
// @ts-ignore
import AnnouncementModal from '@web-packages/components/Views/Globals/AnnouncementModal';
import { getCookieValue, setCookieValue } from '../lib/cookieUtils';

const VIEWED_MESSAGE_IDS_COOKIE = 'viewedMessageIds';
const VIEWED_MESSAGE_IDS_TTL_DAYS = 10;

type AnnouncementMessageItem = {
  id: number;
  type: string;
  richText: string;
};

type AnnouncementMessages = {
  status?: 'draft' | 'published';
  message?: AnnouncementMessageItem[];
} | null;

const getViewedMessageIds = (): number[] => {
  const raw = getCookieValue(VIEWED_MESSAGE_IDS_COOKIE);
  if (!raw) return [];
  try {
    return JSON.parse(raw);
  } catch {
    return [];
  }
};

const markMessageAsViewed = (id: number) => {
  const viewedIds = getViewedMessageIds();
  setCookieValue(VIEWED_MESSAGE_IDS_COOKIE, JSON.stringify([...viewedIds, id]), VIEWED_MESSAGE_IDS_TTL_DAYS);
};

const AnnouncementMessage = ({ announcementMessages = null }: { announcementMessages?: AnnouncementMessages }) => {
  const [activeMessage, setActiveMessage] = useState<AnnouncementMessageItem | null>(null);

  useEffect(() => {
    const viewedIds = getViewedMessageIds();
    const unseenMessage = announcementMessages?.message?.find(({ id }) => !viewedIds.includes(id)) || null;
    setActiveMessage(unseenMessage);
  }, [announcementMessages]);

  if (!activeMessage) return null;

  return (
    <AnnouncementModal
      type={activeMessage.type}
      richText={activeMessage.richText}
      showModal
      setShowModal={() => {
        markMessageAsViewed(activeMessage.id);
        setActiveMessage(null);
      }}
    />
  );
};

export default AnnouncementMessage;
